module.exports = __webpack_public_path__ + "main/assets/public/event/icon-phone.fd7c1849c26b04a9.svg";